module.exports = __webpack_public_path__ + "img/6.c1794ed0.png";